import styled from 'styled-components';
import { theme } from '../../../theme';

export const DivTitle = styled.div`
  display: inline-block;
  align-items: center;
  margin-bottom: 0.615rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};

  svg {
    margin-left: 1rem;
    font-size: 0.75rem !important; // fix for native app
  }
`;
